import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';
import { Mutations } from './mutations';
import { CalendarioActionTypes } from './action-types';
import { CalendarioMutationTypes } from './mutation-types';

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>;

export interface Actions {
  [CalendarioActionTypes.ACTION_SET_CONTEXTO](
    { commit }: AugmentedActionContext,
    payload: Partial<State>,
  ): void;
}

export const actions: ActionTree<State, RootState> & Actions = {
  [CalendarioActionTypes.ACTION_SET_CONTEXTO]({ commit }, payload: Partial<State>) {
    commit(CalendarioMutationTypes.SET_CONTEXTO, payload);
  },
};
